import DeleteIcon from "@mui/icons-material/Delete";

import { AUTH_ROLES } from "api/common/types/auth.types";
import { Product } from "api/memberPortal/project/product/product.types";
import { PRODUCT_STATUSES } from "api/memberPortal/project/product/productStatuses.type";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";
import { useAuth } from "hooks/useAuth";

interface DeleteDraftActionProps {
  product: Product;
  setProduct: (_product: Product) => void;
  setShowDeleteModal: (_state: boolean) => void;
}

const DeleteDraftAction = ({
  product,
  setProduct,
  setShowDeleteModal,
}: DeleteDraftActionProps) => {
  const { permissions } = useAuth();

  const isDraft = product.status === PRODUCT_STATUSES.DRAFT;
  const isNiap = permissions.role_type === AUTH_ROLES.NIAP;

  return (
    <IconMenuItem
      Icon={DeleteIcon}
      label="Delete Draft"
      enabled={isDraft && isNiap}
      onClick={() => {
        setProduct(product);
        setShowDeleteModal(true);
      }}
    />
  );
};

export default DeleteDraftAction;
